export const handleDragStop = (e, data, imgIndex, setImagePosition) => {
    const newPosition = { x: data.x, y: data.y };
    setImagePosition((prevPositions) => {
        const newPositions = prevPositions.slice();
        newPositions[imgIndex] = newPosition;
        return newPositions;
    });
};

// Update saved image position after draagging stops
export const TempHandleDragStop = (e, data, imgIndex, tempImage, x, y, id, { setTempImagePosition, setImagesToUpdate, imagesToUpdate, tempImages, setTempImages, tempTabIndexImages, activeTabIndex, setUpdatedTabIndexImages }) => {
    const newPosition = { x: data.x, y: data.y };

    setTempImagePosition((prevPositions) => {
        const newPositions = prevPositions.slice();
        newPositions[imgIndex] = newPosition;
        return newPositions;
    });

    setImagesToUpdate(imagesToUpdate.concat(tempImage));
    const updatedTempImages = [...tempImages];

    const originalDeviceIndex = tempImages.findIndex((data) => data.id === id);

    const updatedData = {
        ...updatedTempImages[originalDeviceIndex],
        x: x + data.x,
        y: y + data.y,
    };

    updatedTempImages[originalDeviceIndex] = updatedData;
    setTempImages(updatedTempImages);

    let oldtabIndexItem = [...tempTabIndexImages[activeTabIndex]];
    const organizedDeviceIndex = oldtabIndexItem.findIndex(
        (data) => data.id === id
    );

    let newXPosition = x + data.x;
    let newYPosition = y + data.y;

    const newUpdatedData = {
        ...oldtabIndexItem[organizedDeviceIndex],
        x: newXPosition,
        y: newYPosition,
    };

    oldtabIndexItem[organizedDeviceIndex] = newUpdatedData;

    const newTempTabIndexDevices = {
        [activeTabIndex]: oldtabIndexItem,
    };

    setUpdatedTabIndexImages(newTempTabIndexDevices);

};

// Getting height and width of image when resize
export const getDimensions = (e, imgIndex, setImageDimensions) => {
    e.preventDefault();
    const selectedImg = document.getElementById(`displayImage-${imgIndex}`);
    const width = selectedImg.style.width;
    const height = selectedImg.style.height;

    setImageDimensions((prevDimensions) => {
        const newDimensions = prevDimensions.slice();
        newDimensions[imgIndex] = { width, height };
        return newDimensions;
    });
};

// Getting height and width of image when resize saved images
export const TempGetDimensions = (e, imgIndex, id, tempImages, setTempImages) => {
    e.preventDefault();
    const selectedImg = document.getElementById(`tempImg-${imgIndex}`);
    const newWidth = selectedImg.style.width;
    const newHeight = selectedImg.style.height;

    const updatedTempImages = [...tempImages];

    const originalDeviceIndex = tempImages.findIndex((data) => data.id === id);

    const updatedData = {
        ...updatedTempImages[originalDeviceIndex],
        width: newWidth,
        height: newHeight,
    };

    updatedTempImages[originalDeviceIndex] = updatedData;
    setTempImages(updatedTempImages);
};


export const handleSavedDeleteImage = ({ setDeleteContextMenu, tempTabIndexImages, activeTabIndex, selectedImg, setTempTabIndexImages, images, tempImages, setTempImages, setIndexesToDeleteImg, indexesToDeleteImg, imagesRefs }) => {
    setDeleteContextMenu(false); // Close the del   ete context menu

    // Perform null/undefined check on selectedImg
    const updatedImages = tempTabIndexImages[activeTabIndex].filter(
        (image, index) => image.name !== selectedImg.name
    );


    const currentDeviceIndex = tempTabIndexImages[activeTabIndex].findIndex((device) => device.id === selectedImg.id);

    imagesRefs.current[currentDeviceIndex].style.setProperty('transform', 'translate(0px, 0px)', 'important');

    // Create a copy of the original state and update the specific tab index


    const newTabIndexImages = { ...tempTabIndexImages };
    newTabIndexImages[activeTabIndex] = updatedImages;
    setTempTabIndexImages(newTabIndexImages);

    const originalImageIndex = images.find(
        (image) => image.id === selectedImg.id
    );

    const filteredData = tempImages.filter(
        (data) => data.id !== selectedImg.id
    );
    setTempImages(filteredData);
    setIndexesToDeleteImg(indexesToDeleteImg.concat(originalImageIndex.id));
};

// For new Images/Multiple Images
export const handleNewDeleteImage = ({ setDeleteContextMenu, multipleImages, clickedImgIndex, setMultipleImages }) => {
    setDeleteContextMenu(false); // Close the delete context menu
    const updatedImages = multipleImages.filter(
        (image, index) => index !== clickedImgIndex
    );
    setMultipleImages(updatedImages);
};

